import { render, staticRenderFns } from "./Typography2.vue?vue&type=template&id=443447cb&scoped=true"
import script from "./Typography2.vue?vue&type=script&lang=js"
export * from "./Typography2.vue?vue&type=script&lang=js"
import style0 from "./Typography2.vue?vue&type=style&index=0&id=443447cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443447cb",
  null
  
)

export default component.exports